import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const stories = [{
  discipline: 'ENTRENAMIENTO FUNCIONAL',
  quote: '“En las primeras dos semanas activé los guiones de WhatsApp y cerré 3 alumnos nuevos que estaban fríos hace meses.”',
  name: 'Marcos D. — Buenos Aires',
  result: '+3 alumnos en 14 días'
}, {
  discipline: 'BOXEO',
  quote: '“Nunca había pensado en usar Instagram así. Empecé con el módulo 2 y en un mes tuve clientes orgánicos sin pagar nada.”',
  name: 'Valentina R. — Córdoba',
  result: 'Clientes orgánicos en 30 días'
}, {
  discipline: 'CROSSFIT & FUERZA',
  quote: '“El plan de 90 días me dio estructura. Antes improvisaba todo. Ahora sé exactamente qué hacer cada semana.”',
  name: 'Diego F. — Rosario',
  result: 'Sistema activo en 90 días'
}];
type TestimonialCardsProps = {
  compact?: boolean;
};
export function TestimonialCards({
  compact = false
}: TestimonialCardsProps) {
  return <div className="grid gap-4 lg:grid-cols-3" data-id="element-137">
      {stories.map((story, index) => <Reveal key={story.name} delay={index * 0.05} data-id="element-138">
          <figure className={`premium-card flex h-full flex-col bg-card ${compact ? 'p-5' : 'p-7'}`} data-id="element-139">
            <div className="flex items-center justify-between gap-3" data-id="element-140">
              <p className="font-mono text-[9px] font-semibold tracking-[0.13em] text-gold" data-id="element-141">
                {story.discipline}
              </p>
              <div className="flex gap-0.5" aria-label="5 estrellas" data-id="element-142">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} size={12} className="fill-gold text-gold" aria-hidden="true" data-id="element-143" />)}
              </div>
            </div>
            <blockquote className={`flex-1 text-ivory ${compact ? 'mt-5 text-sm leading-6' : 'mt-7 text-base leading-7'}`} data-id="element-144">
              {story.quote}
            </blockquote>
            <figcaption className="mt-7 border-t border-[#d4af37]/18 pt-4" data-id="element-145">
              <p className="text-sm font-semibold text-ivory" data-id="element-146">{story.name}</p>
              <p className="mt-2 font-mono text-[10px] font-semibold uppercase tracking-[0.08em] text-gold" data-id="element-147">
                {story.result}
              </p>
            </figcaption>
          </figure>
        </Reveal>)}
    </div>;
}
export function EarlySocialProof() {
  return <section className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28" data-id="element-148">
      <Reveal data-id="element-149">
        <p className="mb-7 text-center font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-150">
          Lo que dicen los que ya lo tienen
        </p>
      </Reveal>
      <TestimonialCards data-id="element-151" />
    </section>;
}
export function ProStories() {
  return <section className="px-5 py-20 sm:px-8 sm:py-28" data-id="element-152">
      <div className="mx-auto max-w-6xl" data-id="element-153">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-154">
          <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-155">
            Incluido en el Megapack
          </p>
          <h2 className="mt-5 font-display text-4xl font-bold leading-[0.98] tracking-[-0.04em] text-ivory sm:text-5xl" data-id="element-156">
            25 casos de{' '}
            <em className="font-normal text-gold" data-id="element-157">entrenadores reales</em>{' '}
            aplicando estas ideas.
          </h2>
          <p className="mx-auto mt-5 max-w-2xl leading-7 text-sage" data-id="element-158">
            Casos documentados para ver qué hizo cada entrenador, en qué
            disciplina trabajaba y qué resultado consiguió.
          </p>
          <p className="mx-auto mt-7 inline-flex border border-gold bg-[#d4af37]/[0.05] px-3 py-2 font-mono text-[9px] font-semibold uppercase tracking-[0.1em] text-gold" data-id="element-159">
            Boxeo · Funcional · Crossfit · Pilates · Fútbol · Natación + más
          </p>
        </Reveal>
        <div className="mt-12" data-id="element-160">
          <TestimonialCards compact data-id="element-161" />
        </div>
        <Reveal className="mt-9 text-center" data-id="element-162">
          <p className="font-display text-3xl text-ivory" data-id="element-163">
            + 22 casos más incluidos en el Megapack
          </p>
          <a href="https://librofy-store.myshopify.com/cart/47910701957341:1" className="gold-button mt-6 inline-flex min-h-11 items-center justify-center bg-gold px-5 font-mono text-[10px] font-bold uppercase tracking-wider text-ink transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" data-id="element-164">
            Quiero el Megapack — $27.990
          </a>
        </Reveal>
      </div>
    </section>;
}